export const sendEvent = (eventName, params = {}) => {
  if (!window.gtag) return;
  window.gtag('event', eventName, params);
};

export const setAnalyticsUserId = userId => {
  if (!window.gtag) return;
  window.gtag('config', 'G-PVT6PBEWLR', {
    user_id: userId,
  });
};
